function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 86,
  r: 50,
  fill: "#75B943"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 106.352,
  y1: 69.518,
  x2: 82.518,
  y2: 98.6482,
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 66.5113,
  y1: 86.5869,
  x2: 81.5869,
  y2: 98.4887,
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round"
});

function SvgPassedStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassedStatus);
export default __webpack_public_path__ + "static/media/passed_status.3753e555.svg";
export { ForwardRef as ReactComponent };